<div class="modal-body d-flex flex-column pedido-insercao-body">
  <div class="adicionar_itens_menu_mobile_bar">
    <button class="btn btn-outline-secondary btn-sm" type="button" (click)="alternarMenuMobile()">
      {{ menuMobileExpandido ? 'Ocultar menu' : 'Mostrar menu' }}
    </button>
  </div>
  <app-pedido-itens-toolbar
    [configuracao]="configuracao"
    [clienteSelecionado]="clienteSelecionado"
    [prazosPagamentoIniciais]="prazosPagamentoIniciais"
    [prazosPagamentoEspeciais]="prazosPagamentoEspeciais"
    [prazoPagamentoSelecionado]="prazoPagamentoSelecionado"
    [prazoPagamentoInvalido]="prazoPagamentoInvalido"
    [prazoMedio]="prazoMedio"
    [prazoMedioDesconto]="prazoMedioDesconto"
    [contaCorrenteSaldoDisponivel]="contaCorrenteSaldoDisponivel"
    [saldoGeradoValorParcial]="saldoGeradoValorParcial"
    [exibirPontuacao]="exibirPontuacao"
    [pontuacaoTotal]="valorTotalPontuacaoProdutosAdicionados"
    [iaCarregando]="iaCarregando"
    [calculando]="calculando || revalidandoPrazo"
    [menuMobileExpandido]="menuMobileExpandido"
    (prazoAlterado)="alterarPrazoPagamento($event.id_prazo_pagamento, $event.cabecalho, $event.event)"
    (prazoCancelado)="cancelarAlterarPrazoPagamento($event)"
    (iaPainelAlternado)="alternarPainelIa()"
    (produtosSugeridos)="sugerirProdutosIa()"
    (salvarClicado)="salvar()"
    (cancelarClicado)="fechar()">
  </app-pedido-itens-toolbar>

  <app-pedido-itens-ia-painel
    [iaPainelAberto]="iaPainelAberto"
    [iaProdutosPainelAberto]="iaProdutosPainelAberto"
    [clienteSelecionado]="clienteSelecionado"
    [iaSugestao]="iaSugestao"
    [iaProdutoAberto]="iaProdutoAberto"
    [iaConfiguracao]="iaConfiguracao"
    [iaConfiguracaoCarregando]="iaConfiguracaoCarregando"
    [iaHistoricoCarregando]="iaHistoricoCarregando"
    [iaMensagens]="iaMensagens"
    [iaCarregando]="iaCarregando"
    [(iaPergunta)]="iaPergunta"
    (painelFechado)="fecharPainelIa()"
    (produtosPainelFechado)="fecharProdutosIa()"
    (sugestaoAtualizada)="atualizarSugestaoProdutosIa()"
    (perguntaEnviada)="perguntarIa()"
    (perguntaEnviadaPorEnter)="enviarPerguntaIaPorEnter($event)"
    (textoIaCopiado)="copiarTextoIa($event)"
    (historicoRecarregado)="carregarHistoricoIa($event)"
    (produtoIaAlternado)="alternarProdutoIa($event)">
  </app-pedido-itens-ia-painel>

  @if (configuracao != null && ((!configuracao.prazo_pagamento_antes_itenspedido && configuracao.utiliza_fator_financeiro) || configuracao.usa_conta_corrente_flex || (clienteSelecionado != null && (clienteSelecionado.limite_credito_disponivel != null || clienteSelecionado.credito_financeiro != null)))) {
    <hr class="mt-2 mb-2" />
  }

  <!-- Catálogo + Painel de Detalhe (Task 5): substitui filtro + navegação de modo edição +
       aviso de campanhas indisponíveis + lista virtualizada de produtos/campanhas (antigo
       html:261-1170), agora com o painel de detalhe do item lado a lado (desktop) ou em
       drawer full-screen (mobile, <992px). -->
  <div class="pedido-itens-shell">
    <app-pedido-itens-catalogo
      class="pedido-itens-shell-catalogo"
      [produtosExibidos]="produtosExibidos"
      [produtoSelecionadoId]="produtoSelecionado?.id"
      [formFiltroProduto]="formFiltroProduto"
      [filtroProdutos]="filtroProdutos"
      [filtroStatus]="filtroStatus"
      [somentePromocoes]="somentePromocoes"
      (promocoesAlternadas)="toggleSomentePromocoes()"
      [enviadoProduto]="enviadoProduto"
      [filtrandoProduto]="filtrandoProduto"
      [produtosComErro]="produtosComErro"
      [filtroMobileExpandido]="filtroMobileExpandido"
      [isEditMode]="isEditMode"
      [itemEmEdicao]="itemEmEdicao"
      [pedido]="pedido"
      [filtroProdutoSelecionado]="filtroProdutoSelecionado"
      [configuracao]="configuracao"
      [prazoPagamentoSelecionado]="prazoPagamentoSelecionado"
      [exibirPontuacao]="exibirPontuacao"
      [usaPendencia]="usaPendencia"
      [viewportHeight]="viewportHeight"
      [exibirLista]="filtrandoProduto || saldoGeradoErro"
      [modalCampanha]="adicionarItensCampanha"
      (filtroSubmetido)="filtrarProduto()"
      (filtroAlterado)="alterarFiltroProduto($event)"
      (filtroMobileAlternado)="alternarFiltroMobile()"
      (produtoClicado)="selecionarProdutoDoCatalogo($event.id_produto, $event.index)"
      (voltarModoEdicao)="sairModoEdicao()"
      (travaRemovida)="removerTravaPrecoTabela($event)"
      (campanhaAdicionarOuAlterar)="modalAdicionarItensCampanha($event.content, $event.id_campanha)"
      (campanhaExcluida)="excluirProdutoCampanha($event)">
    </app-pedido-itens-catalogo>

    <div class="pedido-itens-shell-detalhe" *ngIf="produtoSelecionado">
      <button type="button" class="btn btn-outline-secondary btn-sm pedido-itens-shell-voltar" (click)="fecharDetalhePainel()">
        <i class="fa fa-arrow-left"></i> Voltar
      </button>
      <app-pedido-itens-detalhe-painel
        [produto]="produtoSelecionado"
        [configuracao]="configuracao"
        [prazoPagamentoSelecionado]="prazoPagamentoSelecionado"
        [tiposPedidoSelecionado]="tiposPedidoSelecionado"
        [pedido]="pedido"
        [exibirPontuacao]="exibirPontuacao"
        [calculando]="calculando || revalidandoPrazo"
        [labelPrecoTravado]="obterLabelPrecoTravado(produtoSelecionado)"
        [modalFotos]="adicionarItensFotos"
        [modalInformacoes]="adicionarItensInformacoes"
        [modalEstoqueLocal]="adicionarItensEstoqueLocal"
        [modalTabelas]="adicionarItensTabelas"
        [modalLotes]="adicionarItensLotes"
        (qtdeAlterada)="validarProdutoQtde($event.id_produto, $event.foco, $event.event)"
        (qtdeIncrementada)="incrementarQtdeProduto($event)"
        (qtdeDecrementada)="decrementarQtdeProduto($event)"
        (edicaoValorIniciada)="iniciarEdicaoValorUnitario($event)"
        (valorDigitado)="aoDigitarValorUnitario($event)"
        (valorValidado)="validarProdutoValor($event.id_produto, $event.foco, $event.event, $event.adicionado)"
        (valorTabelaSelecionado)="selecionarValorProdutoNovo($event.id_produto, $event.preco_unitario)"
        (valorComFatorSelecionado)="selecionarValorProdutoComFator($event.id_produto, $event.valorJaFatorado)"
        (valorLoteSelecionado)="selecionarValorProdutoLote($event.id_produto, $event.preco_lote)"
        (travaRemovida)="removerTravaPrecoTabela($event)"
        (descontoTemporarioDefinido)="definirPorcentagemDescontoTemporario($event)"
        (edicaoDescontoIniciada)="iniciarEdicaoDesconto($event)"
        (edicaoDescontoFinalizada)="finalizarEdicaoDesconto($event.id_produto, $event.event)"
        (descontoUnitarioCalculado)="calcularDescontoUnitario($event.id_produto, $event.alterar, $event.adicionado)"
        (descontoSelecionado)="selecionarDescontoProduto($event.id_produto, $event.po_desconto)"
        (loteRemovido)="removerLoteProduto($event)"
        (loteSelecionado)="selecionarLoteProduto($event)"
        (bonificacaoAlterada)="alterarBonificacao($event)"
        (abrirFotos)="modalAdicionarItensFotos($event.content, $event.id_produto)"
        (abrirInformacoes)="modalAdicionarItensInformacoes($event.content, $event.id_produto)"
        (abrirEstoqueLocal)="modalAdicionarItensEstoqueLocal($event.content, $event.id_produto)"
        (abrirTabelas)="modalAdicionarItensTabelas($event.content, $event.id_produto, $event.id_lote)"
        (abrirLotes)="modalAdicionarItensLotes($event.content, $event.id_produto)">
      </app-pedido-itens-detalhe-painel>
    </div>
  </div>
</div>

<footer class="pedido-insercao-footer">
  <button class="btn btn-outline-primary" type="button" (click)="fechar()">Cancelar</button>
  <button class="btn btn-success" type="button" (click)="salvar()" [disabled]="calculando || revalidandoPrazo">Salvar</button>
</footer>

<!-- Modal (Redução de preço por prazo) -->

<ng-template #confirmarReducaoPrecoPrazo let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-reducao-preco-prazo-itens"><b>Alteração de Prazo</b></h3>
  </div>
  <div class="modal-body">
    <p>O novo prazo tem fator financeiro menor. Deseja <b>reduzir o preço</b> dos itens?</p>
    <p class="text-secondary mb-0">Se mantiver, o preço atual passa a ser a base caso o prazo seja alterado novamente.</p>
  </div>
  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Manter')">Não, manter preço</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Reduzir')">Sim, reduzir</button>
  </div>
</ng-template>

<!-- Modal (Adicionar Itens (Campanha)) -->

<ng-template #adicionarItensCampanha let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-adicionar-itens-campanha"><b>Adicionar Itens (Campanha)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <app-pedido-itens-modal-campanha
      [produtoCampanhaSelecionado]="produtoCampanhaSelecionado"
      [combo]="combo"
      [configuracao]="configuracao"
      [prazoPagamentoSelecionado]="prazoPagamentoSelecionado"
      [exibirPontuacao]="exibirPontuacao"
      [formFiltroProdutoCampanha]="formFiltroProdutoCampanha"
      [enviadoProdutoCampanha]="enviadoProdutoCampanha"
      [filtrandoProdutoCampanha]="filtrandoProdutoCampanha"
      [bonificacaoInvalida]="bonificacaoInvalida"
      (filtroSubmetido)="filtrarProdutoCampanha()"
      (filtroCancelado)="alterarFiltroProdutoCampanha()"
      (qtdeDecrementada)="decrementarQtdeCampanha($event)"
      (qtdeIncrementada)="incrementarQtdeCampanha($event)"
      (qtdeValidada)="validarCampanhaQtde()"
      (qtdeProdutoDecrementada)="decrementarQtdeCampanhaProduto($event)"
      (qtdeProdutoIncrementada)="incrementarQtdeCampanhaProduto($event)"
      (qtdeProdutoValidada)="validarCampanhaProdutoQtde($event)"
      (bonificacaoAlterada)="alterarBonificacao($event)">
    </app-pedido-itens-modal-campanha>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Salvar')">Salvar</button>
  </div>
</ng-template>

<!-- Modal (Adicionar Itens (Estoque Local)) -->

<ng-template #adicionarItensEstoqueLocal let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-adicionar-itens-estoque-local"><b>Adicionar Itens (Estoque Local)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <app-pedido-itens-modal-estoque-local [produtoLocais]="produtoLocais"></app-pedido-itens-modal-estoque-local>
  </div>

  <hr class="mt-2 mb-2" />

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (Adicionar Itens (Fotos)) -->

<ng-template #adicionarItensFotos let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-adicionar-itens-fotos"><b>Adicionar Itens (Fotos)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <app-pedido-itens-modal-fotos [fotos]="produtoFotos" [produtoSelecionado]="produtoFotosSelecionado"></app-pedido-itens-modal-fotos>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (Adicionar Itens (Informações)) -->

<ng-template #adicionarItensInformacoes let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-adicionar-itens-informacoes"><b>Adicionar Itens (Informações)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <app-pedido-itens-modal-informacoes
      [produtoSelecionado]="produtoInformacoesSelecionado"
      [fichasTecnicas]="produtoFichasTecnicas">
    </app-pedido-itens-modal-informacoes>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-success btn_formulario" type="button" (click)="modal.close('Ok')">Ok</button>
  </div>
</ng-template>

<!-- Modal (Adicionar Itens (Lotes)) -->

<ng-template #adicionarItensLotes let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-adicionar-itens-lotes"><b>Adicionar Itens (Lotes)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <app-pedido-itens-modal-lotes
      [produtoSelecionado]="produtoLotesSelecionado"
      [lotes]="produtoLotes"
      (loteSelecionado)="selecionarLoteProduto($event)">
    </app-pedido-itens-modal-lotes>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
  </div>
</ng-template>

<!-- Modal (Adicionar Itens (Tabelas)) -->

<ng-template #adicionarItensTabelas let-modal>
  <div class="modal-header pl-3">
    <h3 class="modal-title" id="titulo-adicionar-itens-tabelas"><b>Adicionar Itens (Tabelas)</b></h3>

    <button class="close" type="button" aria-label="Close" (click)="modal.dismiss('Fechar')">
      <span aria-hidden="true">&times;</span>
    </button>
  </div>

  <div class="modal-body">
    <app-pedido-itens-modal-tabelas
      [produtoTabelasSelecionado]="produtoTabelasSelecionado"
      [produtoTabelas]="produtoTabelas"
      [configuracao]="configuracao"
      [prazoPagamentoSelecionado]="prazoPagamentoSelecionado"
      [exibirPontuacao]="exibirPontuacao"
      (precoAplicadoSemFator)="aplicarPrecoPromocionalETRavar($event.idProduto, $event.preco, $event.produtoTabela, false)"
      (precoAplicadoComFator)="aplicarPrecoPromocionalETRavar($event.idProduto, $event.preco, $event.produtoTabela, true)">
    </app-pedido-itens-modal-tabelas>
  </div>

  <div class="modal-footer flex-wrap">
    <button class="btn btn-secondary btn_formulario" type="button" (click)="modal.close('Cancelar')">Cancelar</button>
  </div>
</ng-template>
